<div class="container">
  <h3>{{ 'CHANGE_PASSWORD_IN_APP' | translation }}</h3>
  <p>{{ 'CHANGE_PASSWORD_QUESTION' | translation }}</p>
  <div class="actions">
    <button (click)="closeModal()"> {{ 'CANCEL' | translation }} </button>
    <button (click)="sendPasswordRequest()"> {{ 'ACCEPT' | translation }} </button>
  </div>
</div>
